/*
 * @Descripttion: 
 * @version: 2.0.0
 * @Author: ck
 * @Date: 2019-09-11 10:36:24
 * @LastEditors: ck
 * @LastEditTime: 2019-09-11 10:36:24
 */
export default function eachHook(router) {
  router.beforeEach((to, from, next) => {

    /* 路由发生变化修改页面title */
    // if (to.meta.title) {
    //   document.title = to.meta.title;
    // } else {
    //   document.title = '首页';
    // }
    next()
  });
}